import React, { useEffect,useState } from "react"
import { MapPin, Globe, Truck, Users, Factory, Navigation } from 'lucide-react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import AOS from "aos"
import map from "../assets/images/map.png"
import cert1 from "../assets/images/IS9001.jpeg"
import cert2 from "../assets/images/ISO 9001.png"
import cert3 from "../assets/images/ISO 45001.jpg"
import cert4 from "../assets/images/ESD 20.20 Certificate_page-0001.jpg"
import "aos/dist/aos.css"
import factory1 from "../assets/images/rudrapur.png"
import factory2 from "../assets/images/bhiwadi.png"
import factory3 from "../assets/images/hyderabad.png"
import factory4 from "../assets/images/noida.png"
import logo1 from "../assets/images/Micromax-logo.png"
import logo2 from "../assets/images/Phison.png"
import logo3 from "../assets/images/miphi_main_logo.png"
import logo4 from "../assets/images/Acer.jpg"
import logo5 from "../assets/images/Play (1) - Copy.jpg"
import logo6 from "../assets/images/omni-remotes.jpeg"
import logo7 from "../assets/images/Wings.jpg"
import logo8 from "../assets/images/ITEL.jpg"
import logo9 from "../assets/images/unnamed-1.jpg"
import logo10 from "../assets/images/Micromax-logo.png"
import logo11 from "../assets/images/Phison.png"
import logo12 from "../assets/images/miphi_main_logo.png"
import logo13 from "../assets/images/Micromax-logo.png"
import logo14 from "../assets/images/TCL.png"
import logo15 from "../assets/images/Lumiford.jpeg"
import logo16 from "../assets/images/Compaq.jpg"
import logo17 from "../assets/images/Acer.jpg"
import logo18 from "../assets/images/unnamed-1.jpg"
import logo19 from "../assets/images/Micromax-logo.png"
import logo20 from "../assets/images/Phison.png"
import logo21 from "../assets/images/miphi_main_logo.png"
import logo22 from "../assets/images/oppo.jpeg"
import logo23 from "../assets/images/vivo.jpeg"
import logo24 from "../assets/images/xiaomi.png"
import logo25 from "../assets/images/Micromax-logo.png"
import logo26 from "../assets/images/Phison.png"
import logo27 from "../assets/images/miphi_main_logo.png"
import InteractiveMap from "../components/Map/InteractiveMap"
const factories = [
  {
    name: "Rudrapur",
    state: "Uttarakhand",
    year: "2012",
    image: factory1,
    partners: [
      { name: "Partner B", logo: logo2 },
      { name: "Partner A", logo: logo1 },
    ],
    areaCoverage: "5 Acres (200,000 Sq.ft.)",
    production: {
      products: ["LED TV", "Mobile-Phones", "Manpower"],
      capacity: ["200K", "500K", "1000+"],
      lines: ["5", "6", "NA"],
    },
    distances: {
      nearestPort: "50 km",
      nearestAirport: "250 km",
    },
  },
  {
    name: "Bhiwadi",
    state: "Rajasthan",
    year: "2017",
    image: factory2,
    partners: [
      { name: "Partner D", logo: logo4 },
      { name: "Partner E", logo: logo5 },
      { name: "Partner E", logo: logo6 },
      { name: "Partner E", logo: logo7 },
      { name: "Partner E", logo: logo8 },
      { name: "Partner E", logo: logo9 },
      { name: "Partner E", logo: logo10 },
      { name: "Partner E", logo: logo11 },
    ],
    areaCoverage: "25 Acres (350,000 Sq.ft.)",
    production: {
      products: ["LED TV", "Mobile-Phones & Tablet PC", "PCB (SMT)", "Manpower"],
      capacity: ["200K", "600K", "500K (Mobile) / 200K (TV)", "2000+"],
      lines: ["4", "12", "4 Lines (2KK CPH)", "NA"],
    },
    distances: {
      nearestPort: "40 km",
      nearestAirport: "50 km",
    },
  },
  {
    name: "Hyderabad",
    state: "Telangana",
    year: "2016",
    image: factory3,
    partners: [
      { name: "Partner D", logo: logo13 },
      { name: "Partner E", logo: logo14 },
      { name: "Partner E", logo: logo15 },
      { name: "Partner E", logo: logo16 },
      { name: "Partner E", logo: logo17 },
      { name: "Partner E", logo: logo18 },
    ],
    areaCoverage: "25 Acres (350,000 Sq.ft.)",
    production: {
      products: ["LED TV", "Mobile-Phones & Tablet PC", "PCB (SMT)", "Manpower"],
      capacity: ["200K", "600K", "100K (Mobile) / 100K (TV)", "2000+"],
      lines: ["4", "6", "1 Line (400K CPH)", "NA"],
    },
    distances: {
      nearestPort: "550 km",
      nearestAirport: "5 km",
    },
  },
  {
    name: "Noida",
    state: "Uttar Pradesh",
    image: factory4,
    year: "2024",
    partners: [
      { name: "Partner E", logo: logo23 },
      { name: "Partner E", logo: logo24 },
      { name: "Partner E", logo: logo25 },
      { name: "Partner E", logo: logo26 },
      { name: "Partner E", logo: logo27 },
      { name: "Partner D", logo: logo22 },
    ],
    areaCoverage: "1,000,000 Sq.ft. (3-10 Story Building)",
    production: {
      products: ["SMT Lines", "Smart Phones", "Manpower"],
      capacity: ["2.5M", "1.5M", "2600"],
      lines: ["12", "15", "NA"],
    },
    distances: {
      nearestPort: "35 km",
      nearestAirport: "55 km",
    },
  },
]

const certificates = [
  { id: 1, name: "ISO 9001", description: "Quality Management System", image: cert2 },
  { id: 2, name: "ISO 14001", description: "Environmental Management System", image: cert1 },
  { id: 3, name: "ESD 20.20", description: "Electrostatic Discharge Control", image: cert4 },
  { id: 4, name: "ISO 45001", description: "Occupational Health and Safety Management Systems", image: cert3 },
]

const addresses = [
  { text: "Rudrapur, Uttarakhand", left: true },
  { text: "Bhiwadi, Rajasthan", left: true },
  { text: "Hyderabad, Telangana", left: true },
  { text: "Noida, Uttar Pradesh", left: true },
]

const FactoryCard = ({ factory, index }) => {
  return (
    <div className="bg-white rounded-lg border overflow-hidden w-full max-w-7xl mx-auto">
      {/* Header Section */}
      <div className="p-4 border-b">
        <div className="flex items-center gap-2">
          <MapPin className="text-orange-500 w-5 h-5" />
          <h2 className="text-xl font-semibold text-gray-800">{factory.name}</h2>
        </div>
        <div className="flex items-center gap-2 ml-7">
          <span className="text-gray-600">{factory.state}</span>
          {factory.year && (
            <span className="text-gray-500">• Est. {factory.year}</span>
          )}
        </div>
      </div>

      {/* Main Content */}
      <div className="flex flex-col lg:flex-row">
        {/* Image Section */}
        <div className="lg:w-2/5 h-64 lg:h-auto relative">
          <img
            src={factory.image || "/api/placeholder/800/600"}
            alt={`${factory.name} Factory`}
            className="w-full h-full object-cover"
          />
        </div>

        {/* Info Section */}
        <div className="lg:w-3/5 p-4">
          <div className="grid md:grid-cols-2 gap-4">
            {/* Coverage Area */}
            <div className="bg-white rounded-lg border p-4">
              <div className="flex items-center gap-2 mb-2">
                <Globe className="text-orange-500 w-5 h-5" />
                <span className="font-medium">Coverage Area</span>
              </div>
              <p className="ml-7 text-gray-600">{factory.areaCoverage}</p>
            </div>

            {/* Distances */}
            <div className="bg-white rounded-lg border p-4">
              <div className="flex items-center gap-2 mb-2">
                <Navigation className="text-orange-500 w-5 h-5" />
                <span className="font-medium">Distances</span>
              </div>
              <div className="ml-7 space-y-2">
                <div className="flex items-center gap-2 text-gray-600">
                  <Truck className="w-4 h-4 text-orange-500" />
                  <span>Dry Port: {factory.distances.nearestPort}</span>
                </div>
                <div className="flex items-center gap-2 text-gray-600">
                  <Navigation className="w-4 h-4 text-orange-500" />
                  <span>Airport: {factory.distances.nearestAirport}</span>
                </div>
              </div>
            </div>

            {/* Production */}
            <div className="bg-white rounded-lg border p-4 md:col-span-2">
              <div className="flex items-center gap-2 mb-3">
                <Factory className="text-orange-500 w-5 h-5" />
                <span className="font-medium">Production</span>
              </div>
              <div className="ml-7 space-y-2">
                {factory.production.products.map((product, idx) => (
                  <div key={idx} className="flex justify-between items-center">
                    <span className="text-gray-600">{product}</span>
                    <div className="flex items-center gap-3">
                      <span className="text-gray-700">{factory.production.capacity[idx]}</span>
                      {factory.production.lines[idx] !== "NA" && (
                        <span className="bg-orange-100 text-orange-800 px-2 py-1 rounded text-sm">
                          {factory.production.lines[idx]} lines
                        </span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Partners */}
            <div className="bg-orange-50 rounded-lg p-4 md:col-span-2">
              <div className="flex items-center gap-2 mb-3">
                <Users className="text-orange-500 w-5 h-5" />
                <span className="font-medium">Partners</span>
              </div>
              <div className="grid grid-cols-4 gap-3 ml-7">
                {factory.partners.map((partner, idx) => (
                  <div key={idx} className="bg-white rounded-lg p-2 flex items-center justify-center">
                    <img
                      src={partner.logo || "/api/placeholder/60/60"}
                      alt={partner.name}
                      className="h-8 w-auto object-contain"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const FactoryCarousel = ({ factories }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);

  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (touchStart - touchEnd > 75) {
      nextSlide();
    }
    if (touchStart - touchEnd < -75) {
      prevSlide();
    }
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex === factories.length - 1 ? 0 : prevIndex + 1));
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? factories.length - 1 : prevIndex - 1));
  };

  return (
    <div className="relative w-full px-4 py-6">
      <div 
        className="relative overflow-hidden min-h-[800px]"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <div
          className="transition-transform duration-500 ease-in-out flex"
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {factories.map((factory, index) => (
            <div
              key={index}
              className="w-full flex-shrink-0"
            >
              <FactoryCard factory={factory} index={index} />
            </div>
          ))}
        </div>
      </div>

      {/* Navigation Buttons */}
      <button
        onClick={prevSlide}
        className="absolute left-0 top-1/2 -translate-y-1/2 bg-white rounded-full p-2 shadow-lg z-10"
        aria-label="Previous"
      >
        <ChevronLeft className="w-6 h-6" />
      </button>
      <button
        onClick={nextSlide}
        className="absolute right-0 top-1/2 -translate-y-1/2 bg-white rounded-full p-2 shadow-lg z-10"
        aria-label="Next"
      >
        <ChevronRight className="w-6 h-6" />
      </button>

      {/* Dots Navigation */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 flex gap-2">
        {factories.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`w-2 h-2 rounded-full ${
              currentIndex === index ? 'bg-orange-500' : 'bg-gray-300'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};
export default function FactoryLocations() {
  useEffect(() => {
    AOS.init({ duration: 1000 })
  }, [])

  return (
    <div className="min-h-screen">
    
       <InteractiveMap/>
     
       {/* <div className="max-w-6xl mx-auto py-8 md:py-12 px-4 sm:px-6 lg:px-8">
      <FactoryCarousel factories={factories} />
    </div> */}
      {/* Certifications Section */}
      <div className=" py-8 md:py-12 px-4 bg-gradient-to-b from-white to-orange-50">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 md:mb-8" data-aos="fade-up">
            Our Certifications
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {certificates.map((cert, index) => (
              <div
                key={cert.id}
                className="bg-white p-4 md:p-6 rounded-lg border hover:shadow-xl transition-transform duration-300 hover:scale-105"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <div className="h-24 md:h-32 flex items-center justify-center mb-4">
                  <img
                    src={cert.image || "/placeholder.svg"}
                    alt={`${cert.name} Certificate`}
                    className="max-h-full w-auto object-contain"
                  />
                </div>
                <h3 className="text-base md:text-lg font-semibold mb-2">{cert.name}</h3>
                <p className="text-sm text-gray-600">{cert.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="relative text-white p-4 md:p-8 overflow-hidden">
        {/* Background Video */}
        <div className="absolute inset-0">
          <video autoPlay loop muted playsInline className="w-full h-full object-cover">
            <source
              src="https://videos.pexels.com/video-files/3129576/3129576-uhd_2560_1440_30fps.mp4"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
          <div className="absolute inset-0 bg-black/50"></div> {/* Overlay */}
        </div>

        {/* Main content */}
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-8 md:gap-12 items-center relative z-10">
          <div className="space-y-4 md:space-y-6">
            <h1
              className="text-3xl md:text-4xl font-light leading-tight tracking-wider mb-4 md:mb-8"
              style={{ fontFamily: "Arial, Helvetica, sans-serif" }}
            >
              <div>Transforming the Future</div>
              <div>with Advanced Manufacturing</div>
              <div>Technology.</div>
            </h1>
          </div>

          <div className="relative">
            {/* Video Section */}
            <div className="aspect-video rounded-lg overflow-hidden shadow-lg">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/-Bt9L1ZFxfM?si=usCZeqJKUAM4FEDt"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
                className="w-full h-full"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

